function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "primary-fill",
  fill: "#688BB7",
  fillRule: "nonzero",
  d: "M6.5 0A6.499 6.499 0 0 0 0 6.497a6.5 6.5 0 0 0 13 0A6.497 6.497 0 0 0 6.5 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "secondary-fill",
  fill: "#FFF",
  d: "M7.5 5.373h-2V11h2V5.373zM5.35 3.098c0 .352.096.62.289.802.192.183.467.275.822.275.35 0 .62-.095.807-.285.188-.19.282-.454.282-.792 0-.337-.095-.605-.285-.802C7.075 2.099 6.807 2 6.46 2c-.35 0-.623.095-.818.285-.195.19-.293.461-.293.813z"
}));

function SvgInfoIcon(_ref, svgRef) {
  let title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.bc296fe51276e9751f9fc7f6c54a1323.svg";
export { ForwardRef as ReactComponent };